import React, { FC } from 'react';
import clsx from 'classnames';
import { VehicleCheckPointIcon, VehicleDocumentsIcon, BikeIcon, CarIcon } from 'common/icons';
import { MyVehicleItem } from 'api/vehicles';
import { getPlateType, InscriptionStatusType, VehicleType } from 'global/utils/plate/patente';
import { FcCancel } from 'react-icons/fc';
import { BikePlate, VehiclePlate } from './plates';

import styles from './vehicle-item.module.scss';

interface Props {
  goToCheckPoint: () => void;
  goToVehicularDocuments: () => void;
  vehicle: MyVehicleItem;
}

export const VehicleItem: FC<Props> = ({ goToCheckPoint, goToVehicularDocuments, vehicle }) => {
  const isBike = getPlateType(vehicle.plate) === VehicleType.BIKE;
  const isCanceled = vehicle?.status === InscriptionStatusType.cancelado;

  return (
    <div>
      <div className={clsx('w-full h-full relative', styles.container)}>
        <div>
          {isCanceled && <FcCancel className="absolute top-1 left-1" size={24} />}
          <div>{isBike ? <BikeIcon /> : <CarIcon />}</div>
          <p>{vehicle.brand}</p>
          <p>{vehicle.year || '-'}</p>
          {isBike ? <BikePlate bike={vehicle} /> : <VehiclePlate vehicle={vehicle} />}
        </div>
        <div className={isCanceled ? styles.divDisabled : ''}>
          <div className={styles.checkPointContainer} tabIndex={0} onClick={goToCheckPoint}>
            <span>
              <VehicleCheckPointIcon />
            </span>
            <span>Control Vehicular</span>
          </div>
          <div tabIndex={0} onClick={goToVehicularDocuments}>
            <span>
              <VehicleDocumentsIcon />
            </span>
            <span>Documentos del vehículo</span>
          </div>
        </div>
      </div>
      {isCanceled && <p className={styles.cancelText}>Inscripción Cancelada</p>}
    </div>
  );
};
